import PageWrap from './PageWrap';
import ContentWrap from './ContentWrap';
import FadeInContainer from './FadeInContainer';

const Layout = {
	PageWrap,
	ContentWrap,
	FadeInContainer,
};

export { PageWrap, ContentWrap, FadeInContainer };
export default Layout;
